export const developEnvVariables = {
  environment: 'development',
  apiHost: 'https://uat-tyonantaja-api.edenred.fi', // DEV 'https://dev-emp-api.fi.edenred.net'; // QA1 'http://fi-cicd.edenred.net:8183'; // QA2 'http://fi-cicd.edenred.net:8083'; //  LOCAL 'https://localhost:44378'; //https://uat-tyonantaja-api.edenred.fi //http://fi-cicd.edenred.net:8083
  enablePersistanceOnLocalStorage: true,
  disablePersistanceCompression: true,
  disableReCaptcha: false,
  googleAnalyticsKey: '',
  onetrustKey: '',
  enableLoadingType: true,
  enableVirikeLoadingType: true,
  enableDepositsUpdate: true,
  depositUpdateAllowedIds: '677;90031096;90031374;345',
  enableMassUpload: true,
  ingestroLicenseKey: 'v8RpnWUn6nzZVM8ieOiI/8ziUQmutDg36wQHaZLghO0=',
  highPrecisionStartDate: '2026-04-15'
};
